<template>
  <div>
    <pageTable/>
  </div>
</template>

<script>
import PageTable from './components/table';
export default {
  name: 'ecom-evgBiz-evgPlanOrder',
  components: {
    PageTable,
  },
}
</script>